import * as React from 'react';
import { noop } from 'lodash';

import type { ConnectFieldResult } from '../connect-field';

export interface ValidationResult {
    valid: boolean;
    timedOut: boolean;
    connectKey: string;
}

export interface ConnectFieldsApi {
    validate: (requestTypeId?: number) => Promise<ValidationResult[]>;
    serialize: (validatedConnectFields: string[], requestTypeId?: number) => Promise<ConnectFieldResult['data'][]>;
}

export interface ConnectFieldContextProp {
    onConnectFieldMount: (connectApi: ConnectFieldsApi) => void;
}

const ConnectFieldContext = React.createContext<ConnectFieldContextProp>({
    onConnectFieldMount: noop,
});

export const asConnectFields = <TProps extends object>(
    options: React.ComponentType<TProps & ConnectFieldContextProp>
) => {
    const Child = options;

    const Component = (props: TProps) => (
        <ConnectFieldContext.Consumer>
            {(value) => <Child {...props} onConnectFieldMount={value.onConnectFieldMount} />}
        </ConnectFieldContext.Consumer>
    );

    const childDisplayName = Child.displayName ?? Child.name ?? 'Component';
    Component.displayName = `asConnectFields(${childDisplayName})`;

    return Component;
};

export default ConnectFieldContext;
